import React, { FC } from 'react'

import { IconPingProps } from './IconPing.types'
import * as Styled from './styles/IconPing.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPing: FC<IconPingProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPingProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPingProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M98.17 87.83a4 4 0 0 0 5.66-5.66L61.66 40 94.83 6.83A4 4 0 0 0 92 0H20a4 4 0 0 0-4 4v72a4 4 0 0 0 6.83 2.83L56 45.66zM24 8h58.34L24 66.34z' />
        <path d='M141.53 80.3a4 4 0 0 0-4.36.87L104 114.34 61.83 72.17a4 4 0 0 0-5.66 5.66L98.34 120l-33.17 33.17A4 4 0 0 0 68 160h72a4 4 0 0 0 4-4V84a4 4 0 0 0-2.47-3.7zM136 152H77.66L136 93.66z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPing
